module.exports = __webpack_public_path__ + "img/map-search.5de1ff6f.svg";